module.exports = __webpack_public_path__ + "img/cd.7c302226.svg";